/* eslint-disable no-underscore-dangle */
import _ from 'lodash';

export default class NotificationCollection {
  constructor(data) {
    this.data = data || [];
  }

  has(id) {
    return !!_.find(this.data, { id });
  }

  find(id) {
    return _.find(this.data, { id });
  }

  findIndex(id) {
    return _.findIndex(this.data, { id });
  }

  length() {
    return this.data.length;
  }

  getByIndex(index) {
    return this.data[index];
  }

  loop(eachCallback) {
    _.forEach(this.data, (notification, index) => eachCallback(notification, index));
  }

  map(mapCallback) {
    return _.map(this.data, mapCallback);
  }

  get data() {
    return this._data;
  }

  set data(value) {
    this._data = value;
  }
}
